import { FC } from 'react';
import { Text } from '@weave/design-system';
import { Category, CategoryOption } from '@forms-exp/types';
import { FIELD_OPTIONS_THRESHOLD } from '@forms-exp/constants';
import InlineCategorizedChecklist from './inline-categorized-checklist/inline-categorized-checklist.component';
import DropdownCategorizedChecklist from './dropdown-categorized-checklist/dropdown-categorized-checklist.component';
import { textStyle } from './categorized-checklist.style';

const DEFAULT_OPTIONS: CategoryOption[] = [];

interface CategorizedChecklistProps {
  fieldProps: any; // TODO: Add proper type
  category: Category;
}

const CategorizedChecklist: FC<CategorizedChecklistProps> = ({
  fieldProps,
  category: { id, name, options = DEFAULT_OPTIONS },
}) => {
  const shouldShowDropdown = options?.length > FIELD_OPTIONS_THRESHOLD;

  return (
    <div>
      <Text as="label" css={textStyle}>
        {name}
      </Text>
      {!shouldShowDropdown ? (
        <InlineCategorizedChecklist
          fieldProps={fieldProps}
          categoryId={id}
          options={options}
        />
      ) : (
        <DropdownCategorizedChecklist
          fieldProps={fieldProps}
          categoryId={id}
          options={options}
        />
      )}
    </div>
  );
};

export default CategorizedChecklist;
